/**
 * @generated SignedSource<<2d14e70343a1b400d36561fc0bc5a164>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type JiraBoardType = "KANBAN" | "SCRUM" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JswBoards$data = {
  readonly boards: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __id: string;
        readonly boardId: AGG$Long | null | undefined;
        readonly boardType: JiraBoardType | null | undefined;
        readonly canEdit: boolean | null | undefined;
        readonly defaultNavigationItem: {
          readonly url?: string | null | undefined;
        } | null | undefined;
        readonly favouriteValue: {
          readonly isFavourite: boolean | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly isFavourite: boolean | null | undefined;
  readonly mostRecentlyViewedBoard: {
    readonly boardId?: AGG$Long | null | undefined;
  } | null | undefined;
  readonly projectId: string;
  readonly projectKey: string;
  readonly projectType: JiraProjectType | null | undefined;
  readonly softwareBoardCount: AGG$Long;
  readonly " $fragmentSpreads": FragmentRefs<"BoardActions">;
  readonly " $fragmentType": "JswBoards";
};
export type JswBoards$key = {
  readonly " $data"?: JswBoards$data;
  readonly " $fragmentSpreads": FragmentRefs<"JswBoards">;
};

import JswBoardsRefetchQuery_graphql from './JswBoardsRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v2 = {
  "kind": "ScalarField",
  "name": "boardId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "noOfBoardsToFetch"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [
        "node"
      ],
      "operation": JswBoardsRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "JswBoards",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardActions"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW",
      "path": "projectId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "projectKey"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "noOfBoardsToFetch"
        }
      ],
      "concreteType": "JiraBoardConnection",
      "kind": "LinkedField",
      "name": "boards",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraBoardEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraBoard",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "name"
                },
                (v2/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "defaultNavigationItem",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "url"
                        }
                      ],
                      "type": "JiraNavigationItem",
                      "abstractKey": "__isJiraNavigationItem"
                    }
                  ]
                },
                {
                  "concreteType": "JiraFavouriteValue",
                  "kind": "LinkedField",
                  "name": "favouriteValue",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "boardType"
                },
                {
                  "kind": "ScalarField",
                  "name": "canEdit"
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                      },
                      "action": "THROW",
                      "path": "boards.edges.node.__id"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "mostRecentlyViewedBoard",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v2/*: any*/)
          ],
          "type": "JiraBoard"
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
      },
      "action": "THROW",
      "path": "softwareBoardCount"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "3c773ea42ae4857f7fb5a6cc007cd433";

export default node;
